module.exports = __webpack_public_path__ + "static/media/bankAccountDetailsillustration.ba5dc6aa.svg";